// Шум, который мы не контролируем, — глотаем до отправки в Sentry.
// Наши ошибки под эти фильтры не попадают: проверено в __tests__/sentryFilters.test.js.

// Cookie-виджет Usercentrics (issue LINKED-COFFEE-T): у части посетителей блокировщик
// или сетевой фильтр режет подгрузку его UI-чанка. Это не наш код.
export const USERCENTRICS_URL = 'app.usercentrics.eu';

// Расширения браузера (issue LINKED-COFFEE-S) — их скрипты попадают в стек, но не наши.
export const EXTENSION_URL_PATTERNS = ['chrome-extension://', 'moz-extension://'];

export const denyUrls = [USERCENTRICS_URL, ...EXTENSION_URL_PATTERNS];

export const ignoreErrors = [
    // Browser extensions (Grammarly, translators) modify DOM nodes that React manages
    "Failed to execute 'removeChild' on 'Node'",
    "Failed to execute 'insertBefore' on 'Node'",
    "Failed to execute 'appendChild' on 'Node'",
    // Сам загрузчик Usercentrics: сообщение ошибки несёт URL чанка, стек может его не нести
    `Failed to fetch dynamically imported module: https://${USERCENTRICS_URL}`,
];
